import { sectionToComponentDict } from './constants';
import { StyledSectionContainer } from './styles';
import { HalalShopPageSection } from './types';

import { Tabs, TabsTabItem } from '@components';
import { useAuthProtection } from '@hooks/useAuthProtection';
import { useSearchParam } from '@hooks/useSearchParam';
import { MainLayout } from '@layouts/MainLayout';
import { FC, useEffect, useMemo, useState } from 'react';

export const HalalShopPage: FC = () => {
  useAuthProtection();

  const tabs: TabsTabItem<HalalShopPageSection>[] = useMemo(() => {
    return [
      {
        value: HalalShopPageSection.Orders,
        label: `Заказы`,
      },
      {
        value: HalalShopPageSection.Catalog,
        label: `Каталог`,
      },

      {
        value: HalalShopPageSection.Establishment,
        label: `Мой магазин`,
      },
      {
        value: HalalShopPageSection.Returns,
        label: `Возвраты`,
      },
      {
        value: HalalShopPageSection.Finances,
        label: `Финансы`,
      },
      // {
      //   value: HalalShopPageSection.Statistic,
      //   label: `Статистика`,
      // },
    ];
  }, []);

  const [section, setSection] = useSearchParam<HalalShopPageSection>({
    paramName: 'section',
    defaultValue: HalalShopPageSection.Orders,
  });

  // логика сброса индекса страницы на 1 при переключении секций.
  // Триггер тут необходим для привязки к моменту переключения, чтобы он стр не сбрасывалась на 1 в других случаях.
  const [isSectionChangedTrigger, setIsSectionChangedTrigger] =
    useState<boolean>(false);

  const [, setPageIndex] = useSearchParam<string>({
    paramName: 'page',
    defaultValue: '1',
  });

  useEffect(() => {
    if (isSectionChangedTrigger) {
      setPageIndex('1');
      setIsSectionChangedTrigger(false);
    }
  }, [isSectionChangedTrigger, section, setPageIndex]);

  const onChangeSection = (sectionValue: HalalShopPageSection) => {
    setIsSectionChangedTrigger(true);
    setSection(sectionValue);
  };
  // Конец логики. (дальше начинается безумие...)

  return (
    <MainLayout.Content>
      <MainLayout.Content.Header>
        Мой магазин HalalShop
      </MainLayout.Content.Header>
      <Tabs tabs={tabs} value={section} onChange={onChangeSection} />
      <StyledSectionContainer>
        {sectionToComponentDict[section]}
      </StyledSectionContainer>
    </MainLayout.Content>
  );
};
